import {makeAutoObservable} from "mobx";
import EmailCustomizationStore from "./email-customization-store";
import EmailSettingStore from "./email-setting-store";


class EmailNotificationsMainStore {
	private _emailSettingStore = EmailSettingStore;
	private _emailCustomizationStore = EmailCustomizationStore;	

	constructor() {
		makeAutoObservable(this, {}, { autoBind: true });
	}

	public get emailSettingStore() { return this._emailSettingStore; }
	public get emailCustomizationStore() { return this._emailCustomizationStore; }

	hasChanges(): boolean {
		return this._emailSettingStore.hasChanges() || this._emailCustomizationStore.hasChanges();
	}
	
	discardChanges() {
		this._emailSettingStore.discardChanges();
        this._emailCustomizationStore.discardChanges();
	}

	async save() {
		const promises = [];
		if (this._emailSettingStore.hasChanges()) {
			promises.push(this._emailSettingStore.save());
		}
		if (this._emailCustomizationStore.hasChanges()) {
			promises.push(this._emailCustomizationStore.save());
		}
		return await Promise.all(promises);
    }

	async load() {
		return Promise.all([
			this._emailSettingStore.load(),
			this._emailCustomizationStore.load(),
		]);
    }

	public get isLoading(): boolean {
		return this._emailSettingStore.isLoading || this._emailCustomizationStore.isLoading;
	}
	
	public get isSaving(): boolean { return this._emailSettingStore.isSaving() || this._emailCustomizationStore.isSaving();}
}

export default new EmailNotificationsMainStore();